import { Loader } from '@googlemaps/js-api-loader';

async function loadLeaflet() {
  if (!window.L) {
    const L = await import(/* webpackChunkName: "leaflet" */ 'leaflet');
    console.warn('🍃 Leaflet was loaded asynchronously.');
    window.L = L;
  }else{
    console.warn('🍃 Leaflet is already loaded.');
  }
}


document.addEventListener('DOMContentLoaded', () => {
  loadLeaflet().then(() => {

    window.MapController = function (map_settings, data) {
      this.data = data;
      this.container_id = map_settings.container_id;
      this.map = null;
      this.center = map_settings.center;
      this.tiles_provider = map_settings.tiles_provider;
      this.zoom_level = parseInt(map_settings.zoom_level);
      this.lightboxable = true;
      this.tokens = {
        googlemaps: mwl_map.googlemaps.api_key,
        mapbox: mwl_map.mapbox.api_key,
        maptiler: mwl_map.maptiler.api_key
      };
      this.styles = {
        mapbox: mwl_map.mapbox.style,
        googlemaps: mwl_map.googlemaps.style
      };

      this.createMap = function (callback) {
        if (this.tiles_provider === 'googlemaps') {
          const loader = new Loader({
            apiKey: this.tokens[this.tiles_provider],
            version: "weekly"
          });

          loader.load().then(() => {
            this.map = new google.maps.Map(document.getElementById(this.container_id), {
              center: { lat: -34.397, lng: 150.644 },
              zoom: this.zoom_level
            });

            this.map.setOptions({ styles: this.styles.googlemaps });

            callback();
          });
        } else {
          if (L.DomUtil.get(this.container_id) != null) {
            L.DomUtil.get(this.container_id)._leaflet_id = null;
            this.map = L.map(this.container_id).setView(this.center, this.zoom_level);

            callback();
          }
        }
      };

      this.addTilesLayer = function () {
        if (this.tiles_provider == 'openstreetmap') {
          const url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
          const attribution = 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors';
          L.tileLayer(url, {
            attribution: attribution,
            maxZoom: 18,
            noWrap: true,
            style: 'https://openmaptiles.github.io/osm-bright-gl-style/style-cdn.json'
          }).addTo(this.map);
        }
        if (this.tiles_provider == 'maptiler') {
          const url = 'https://api.maptiler.com/maps/basic/{z}/{x}/{y}.png?key=' + this.tokens[this.tiles_provider];
          const attribution = '© MapTiler © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors';
          L.tileLayer(url, {
            attribution: attribution,
            maxZoom: 18,
            noWrap: true
          }).addTo(this.map);
        }
        if (this.tiles_provider == 'mapbox') {
          let url;
          if (this.styles.mapbox?.username && this.styles.mapbox?.style_id) {
            const mapbox_style = this.styles.mapbox;
            url = 'https://api.mapbox.com/styles/v1/' + mapbox_style.username + '/' + mapbox_style.style_id + '/tiles/{z}/{x}/{y}?access_token=' + this.tokens[this.tiles_provider];
          } else {
            url = 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=' + this.tokens[this.tiles_provider];
          }
          const attribution = 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>';
          L.tileLayer(url, {
            attribution: attribution,
            tileSize: 512,
            maxZoom: 18,
            zoomOffset: -1,
            id: 'mapbox/streets-v12',
          }).addTo(this.map);
        }
      };

      function getLargestImageAvailable(image) {
        if (image.sizes.large) {
          return image.sizes.large;
        }
        if (image.sizes.medium) {
          return image.sizes.medium;
        }
        if (image.sizes.thumbnail) {
          return image.sizes.thumbnail;
        }
      }

      function createGmapMarkers(data, app) {
        function CustomMarker(latlng, map, imageSrc) {
          this.latlng_ = latlng;
          this.imageSrc = imageSrc;
          this.setMap(map);
        }

        CustomMarker.prototype = new google.maps.OverlayView();

        CustomMarker.prototype.draw = function () {
          let div = this.div_;
          if (!div) {
            div = this.div_ = document.createElement('div');
            div.className = "gmap-image-marker";


            const img = document.createElement("img");
            img.src = this.imageSrc;
            div.appendChild(img);

            const panes = this.getPanes();
            panes.overlayImage.appendChild(div);
          }

          const point = this.getProjection().fromLatLngToDivPixel(this.latlng_);
          if (point) {
            div.style.left = point.x + 'px';
            div.style.top = point.y + 'px';
          }
        };

        CustomMarker.prototype.remove = function () {
          if (this.div_) {
            this.div_.parentNode.removeChild(this.div_);
            this.div_ = null;
          }
        };

        CustomMarker.prototype.getPosition = function () {
          return this.latlng_;
        };

        for (let i = 0; i < data.length; i++) {
          const img_gps_as_array = data[i].data.gps.split(',');
          const image = {
            image: getLargestImageAvailable(data[i]),
            pos: [img_gps_as_array[0], img_gps_as_array[1]]
          };
          new CustomMarker(new google.maps.LatLng(image.pos[0], image.pos[1]), app.map, image.image);
        }
      }

      function createLeafletMarker(index, image, app) {
        let lightboxable;
        app.lightboxable ? lightboxable = 'inline-block' : lightboxable = 'none';
        let image_marker_markup = [
          '<div class="image-marker-container" data-image-index="' + index + '">',
          '<div class="rounded-image" style="background-image: url(' + getLargestImageAvailable(image) + ')">',
          '<img src="' + getLargestImageAvailable(image) + '" srcset="' + image.file_srcset + '" sizes="' + image.file_sizes + '" style="display: ' + lightboxable + '" alt="' + image.title + '">',
          '</div>',
          '</div>'
        ];
        image_marker_markup = image_marker_markup.join('');

        const icon = L.divIcon({
          className: 'image-marker',
          iconSize: null,
          html: image_marker_markup
        });

        const gps_as_array = image.data.gps.split(',');
        const pos = gps_as_array;

        return L.marker(pos, { icon: icon });
      }

      this.addMarkers = function () {
        if (this.tiles_provider === 'googlemaps') {
          createGmapMarkers(data, this);
        } else {
          this.data.forEach((index, image) => {
            createLeafletMarker(image, index, this).addTo(this.map);
          });
        }
      };

      this.fitMarkers = function () {
        if (this.tiles_provider === 'googlemaps') {
          const bounds = new google.maps.LatLngBounds();
          this.data.forEach(image => {
            const gps_as_array = image.data.gps.split(',');
            const pos = {
              lat: parseFloat(gps_as_array[0]),
              lng: parseFloat(gps_as_array[1])
            };
            bounds.extend(pos);
          });
          this.map.fitBounds(bounds);
          const zoomChangeListener = google.maps.event.addListener(this.map, "idle", () => {
            this.map.setZoom(this.zoom_level);
            google.maps.event.removeListener(zoomChangeListener);
          });
        } else {
          const latLngArray = [];
          this.data.forEach(image => {
            const imageLatLng = image.data.gps.split(',');
            latLngArray.push(imageLatLng);
          });

          const bounds = new L.LatLngBounds(latLngArray);

          this.map.fitBounds(bounds);
          this.map.setZoom(this.zoom_level);
        }
      };
    };

    window.mwlInitMap = function (map_id, image) {
      if (!mwl_map.zoom_level) {
        mwl_map.zoom_level = 12;
      }
      const map_settings = {
        tiles_provider: mwl_map.default_engine,
        container_id: map_id,
        zoom_level: mwl_map.zoom_level,
        center: [parseFloat(image.gps.lat), parseFloat(image.gps.lng)]
      };

      const map_data = [
        {
          file: 'lightbox_image_file',
          file_srcset: image.srcset,
          file_sizes: image.sizes,
          dimension: image.dimensions,
          sizes: {
            thumbnail: image.low_res_src,
            medium: image.low_res_src,
            large: image.src
          },
          data: {
            caption: image.exifs.caption,
            gps: `${image.gps.lat},${image.gps.lng}`
          },
          title: image.title,
        }
      ];

      const mapController = new window.MapController(map_settings, map_data);
      mapController.createMap(() => {
        mapController.addTilesLayer();
        mapController.addMarkers();
        mapController.fitMarkers();
      });

      document.querySelector('body').addEventListener('removeMwlMap', () => {
        mapController.removeMap();
      });
    };
  });
});
